export enum PropositionType {
  MonthlySubs = 'monthly_subs',
  AnnualPrepay = 'annual_prepay',
}
